import type { CompanyArtistType as ApiCompanyArtistType } from 'src/api/generated/touring/types';
import type { CompanyArtistType } from '../../types';
import { mapCompanyArtistContactType } from '../mapCompanyArtistContactType';

export const mapCompanyArtistType = (
  api: ApiCompanyArtistType
): CompanyArtistType => ({
  artist: api.artist,
  contacts: api.contacts.map(mapCompanyArtistContactType),
});
